// profile/ProfileHeader.jsx
import React from 'react';
import { FaInstagram } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import styles from './styles/ProfileHeader.module.css';
import SocialLinks from './SocialLinks';
import { useTranslation } from 'react-i18next';

const normalizeUrl = (url) => {
  if (!url) return '';
  const trimmed = url.trim();
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return 'https://' + trimmed;
};

const ProfileHeader = ({ user, isOwner }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('profile');
  if (user?.role === 'buyer' && isOwner) return null;
  return (
    <div className={styles.profileHeader}>
      <div className={styles.imageWrapper}>
        <img
          src={user.profile_image_url || '/default-profile.png'}
          alt={t('profileImageAlt')}
          className={styles.profileImage}
        />
      </div>
      <div className={styles.info}>
        <h2 className={styles.name}>
          {user.organization_name}
          {(user.instagram || user.twitter) && (
            <span className={styles.socialInline}>
              {user.instagram && (
                <a
                  href={normalizeUrl(user.instagram)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialIcon}
                  aria-label="Instagram"
                >
                  <FaInstagram />
                </a>
              )}
              {user.twitter && (
                <a
                  href={normalizeUrl(user.twitter)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialIcon}
                  aria-label={t('twitterAriaLabel')}
                  title="X"
                >
                  <FaXTwitter />
                </a>
              )}
            </span>
          )}
        </h2>
        {(user.description || user.bio) && <p className={styles.bio}>{user.description || user.bio}</p>}
        <SocialLinks links={user.social_links} />
        {isOwner && (
          <button className={styles.editButton} onClick={() => navigate('/profile/edit')}>{t('editProfile')}</button>
        )}
      </div>
    </div>
  );
};

export default ProfileHeader;